export default ({ store, $config }) => {
  // if (store.state.country === 'ec') {
  const script = document.createElement('script')
  script.innerHTML = 'function loadScript(a){var b=document.getElementsByTagName("head")[0],c=document.createElement("script");c.type="text/javascript",c.src="https://tracker.metricool.com/resources/be.js",c.onreadystatechange=a,c.onload=a,b.appendChild(c)}loadScript(function(){beTracker.t({hash:"2428543bd0004f2d39efb4a5039adfa2"})});'
  script.async = true
  document.getElementsByTagName('head')[0].appendChild(script)
}
